import { render, staticRenderFns } from "./ChipLabelInput.vue?vue&type=template&id=2de8d1af&scoped=true"
import script from "./ChipLabelInput.vue?vue&type=script&lang=js"
export * from "./ChipLabelInput.vue?vue&type=script&lang=js"
import style0 from "./ChipLabelInput.vue?vue&type=style&index=0&id=2de8d1af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8d1af",
  null
  
)

export default component.exports